import * as Yup from 'yup';

const INITIAL_VALUES = {
  password: '',
  confirmPassword: '',
  acknowledge: false
};

const VALIDATION_SCHEMA = Yup.object().shape({
  password: Yup.string()
    .label('Password')
    .required('Password is a required field.').nullable()
    .matches(/[a-z]+/, "Password isn't secure.")
    .matches(/[A-Z]+/, "Password isn't secure.")
    .matches(/[@$!%*#?&]+/, "Password isn't secure.")
    .matches(/\d+/, "Password isn't secure.")
    .min(8, "Password should be more than 8 characters.")
    .max(20, 'Max of 20 characters allowed'),


  confirmPassword: Yup.string().required('Confirm password  is a required field.').oneOf(
    [Yup.ref('password'), null],
    'Passwords must match.'
  ),

});

export { INITIAL_VALUES, VALIDATION_SCHEMA };
